/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PhysicalCountSessionSummaryDto = {
  id: number;
  code: string;
  status: PhysicalCountSessionSummaryDto.status;
  locationId: number;
  locationName: string;
  sessionDate: string;
  comparedAt?: string;
  expectedCount: number;
  actualCount: number;
  successCount: number;
  missingCount: number;
  /**
   * Missing lines not yet written off in inventory
   */
  pendingMissingCount?: number;
  excessCount: number;
  duplicateCount: number;
  scannedNotAvailableCount: number;
  createdBy?: string;
  createdAt: string;
};
export namespace PhysicalCountSessionSummaryDto {
  export enum status {
    OPEN = 'open',
    FINALIZED = 'finalized',
  }
}
